/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ErrorMessageDto } from './ErrorMessageDto';
import type { IntegrationAssetDto } from './IntegrationAssetDto';
import type { SuccessMessageDto } from './SuccessMessageDto';

export type AssetListRefreshRunReportDto = {
    deactivatedAssets: Array<IntegrationAssetDto>;
    errorMessages: Array<ErrorMessageDto>;
    newIncludedAssets: Array<IntegrationAssetDto>;
    newNotIncludedAssets: Array<IntegrationAssetDto>;
    retrievedIncludedAssets: Array<IntegrationAssetDto>;
    retrievedNotIncludedAssets: Array<IntegrationAssetDto>;
    status: AssetListRefreshRunReportDto.status;
    successMessages: Array<SuccessMessageDto>;
};

export namespace AssetListRefreshRunReportDto {

    export enum status {
        SUCCESS = 'SUCCESS',
        FAILURE = 'FAILURE',
    }


}
